import React from 'react';
import pt from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Container from '../../../modules/container';
import { combine } from '../../../helpers/styles';
import 'react-tabs/style/react-tabs.css';
import * as styles from './styles.module.scss';

const CustomTabs = ({
  tabList,
  tabPanels,
  tabListClassName,
  forceRenderTabPanel,
}) => (
  <Tabs forceRenderTabPanel={forceRenderTabPanel}>
    <Container className={styles.tabListContainer}>
      <TabList className={combine(styles.tabList, tabListClassName)}>
        {tabList.map((item, index) => (
          <Tab
            className={styles.tab}
            selectedClassName={styles.selectedTab}
            key={`tab-${index}`}
          >
            {item}
          </Tab>
        ))}
      </TabList>
      <div className={combine(styles.gradientOverlay, styles.left)} />
      <div className={combine(styles.gradientOverlay, styles.right)} />
    </Container>

    {tabPanels.map((TabItem, index) => (
      <TabPanel key={`tabpanel-${index}`}>{TabItem}</TabPanel>
    ))}
  </Tabs>
);

CustomTabs.propTypes = {
  tabList: pt.array.isRequired,
  tabPanels: pt.array.isRequired,
  tabListClassName: pt.string,
  forceRenderTabPanel: pt.bool,
};

CustomTabs.defaultProps = {
  tabListClassName: '',
  forceRenderTabPanel: false,
};

export default CustomTabs;
